module.exports = __webpack_public_path__ + "media/images/2017-e33c9598be4deedfb133d7199719b1ff.png";